import { createContext } from "react";

import type useGroupIdentityById from "src/hooks/data/load/useGroupIdentityById";

/**
 * Describes the group identity loader state and its refresh/cache actions.
 */
export interface IGroupIdentityContext extends ReturnType<typeof useGroupIdentityById> {}

/**
 * Shares group identity state with descendants.
 *
 * Postconditions: Without a provider, data and error are undefined and both activity flags are
 * false. Default mutate and refresh calls fulfill with undefined without loading or updating data.
 * Assumptions: Consumers need a matching provider to observe live request state.
 */
export const GroupIdentityContext = createContext<IGroupIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined
});

export default GroupIdentityContext;
